import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { JwtPayload } from 'jwt-decode';
import { PersonnelType } from '@core/data-access';
import { BehaviorSubject } from 'rxjs';

export type PersonnelJwt = JwtPayload & {
  caseId: number | null;
  personnelId: number | null;
  type: PersonnelType | null;
};

type State = {
  flow: PersonnelType | null;
  accessToken: string | null;
  jwt: PersonnelJwt | null;
};

const initialState: State = { flow: null, accessToken: null, jwt: null };

@Injectable()
export class DataAccessStore extends ComponentStore<State> {
  readonly setAccessToken = this.updater<string>((_, accessToken) => ({ ..._, accessToken }));
  readonly accessToken$ = this.select(state => state.accessToken);

  readonly setFlow = this.updater<PersonnelType>((_, flow) => ({ ..._, flow }));
  readonly flow$ = this.select(state => state.flow);

  readonly setJwt = this.updater<PersonnelJwt>((_, jwt) => {
    this.jwt$.next(jwt);
    return { ..._, jwt };
  });
  readonly jwt$ = new BehaviorSubject<PersonnelJwt | null>(null);

  constructor() {
    super(initialState);
  }
}
